import { render } from "./ChoiceChipTypeComponent.vue?vue&type=template&id=670a4d8c&scoped=true"
import script from "./ChoiceChipTypeComponent.vue?vue&type=script&lang=js"
export * from "./ChoiceChipTypeComponent.vue?vue&type=script&lang=js"

import "./ChoiceChipTypeComponent.vue?vue&type=style&index=0&id=670a4d8c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-670a4d8c"]])

export default __exports__